import * as actions from "../actions/actions";
import { connect } from "react-redux";

import React from "react";

import AdSpace from "./nounproject-adspace";
import IconList from "./nounproject-iconlist";

class FeaturedCollection extends React.Component {
    static defaultProps = {
        adSpace: false,
        collectionMetadata: []
    };
    static propTypes = {
        adSpace: React.PropTypes.bool.isRequired,
        collectionMetadata: React.PropTypes.array.isRequired
    };

    componentDidMount() {
        this.fetchCollection();
    }

    constructor(props) {
        super(props);

        this.state = {
            icons: undefined
        };
    }

    fetchCollection() {
        this.props.fetchFeaturedCollection(
            this.props.collectionMetadata[this.props.collectionIndex].id,
            1,
            this.props.maxIcons
        );
    }

    render() {
        let collection = this.renderFeaturedCollection();

        return (
            <div className="featured-collection-container margin-t-xxl">
                {collection}
            </div>
        );
    }

    renderCollectionPermalink() {
        let collectionPermalink,
            currentCollection = this.props.collectionMetadata[
                this.props.collectionIndex
            ];

        if (currentCollection !== undefined) {
            collectionPermalink = (
                <a
                    className="text-link margin-t-m"
                    href={
                        this.props.collectionMetadata[
                            this.props.collectionIndex
                        ].permalink
                    }
                >
                    View{" "}
                    {
                        this.props.collectionMetadata[
                            this.props.collectionIndex
                        ].name
                    }{" "}
                    Collection
                </a>
            );
        }

        return collectionPermalink;
    }

    renderFeaturedCollection() {
        let adSpace,
            collectionPermalink = this.renderCollectionPermalink(),
            columnsClasses = ["col-lg-12", "col-md-12", "col-xs-12"],
            iconSize = "84";

        if (this.props.adSpace) {
            adSpace = <AdSpace />;
            columnsClasses = ["col-lg-8", "col-sm-6", "col-xs-12"];
            iconSize = "42";
        }

        return (
            <div className="container row margin-t-xxl">
                <style>
                    {`
                    .featured-collection{
                        background: #FFFFFF;
                        border: solid 3px #F2F2F2;
                        min-height: 266px;
                        padding: 24px;
                        text-align: center;
                    }
                    `}
                </style>
                <div className={columnsClasses.join(" ")}>
                    <div className="featured-collection">
                        <IconList
                            maxIcons={this.props.maxIcons}
                            iconSize={iconSize}
                            icons={this.props.icons}
                        />
                        {collectionPermalink}
                    </div>
                </div>
                {adSpace}
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let icons = [];

    if (state.icons.featured_collections) {
        let collection;
        if (
            ownProps.collectionMetadata[ownProps.collectionIndex] !== undefined
        ) {
            collection =
                state.icons.featured_collections[
                    ownProps.collectionMetadata[ownProps.collectionIndex].id
                ];
        }
        if (collection) {
            collection.keys.forEach(iconId => {
                let icon = collection[iconId];
                // hack to attach collection permalink to icon
                icon.permalink =
                    ownProps.collectionMetadata[
                        ownProps.collectionIndex
                    ].permalink;
                icons.push(collection[iconId]);
            });
        }
    }

    return { icons };
}

module.exports = connect(mapStateToProps, {
    fetchFeaturedCollection: actions.fetchFeaturedCollection
})(FeaturedCollection);
